import { PropsWithChildren } from 'react'

import { Box, Page } from '@revolut-internal/ui-kit'

import { useChannel } from 'hooks/useChannel'
import { useQueueStatsFilterQuery } from 'modules/api/analytics/queries'
import { Security } from 'modules/security/security'

import { AdditionalFiltersProvider } from './GlobalFilters/AdditionalFilters/AdditionalFiltersContext'
import { GlobalFilters } from './GlobalFilters/GlobalFilters'

export const Monitoring = ({ children }: PropsWithChildren) => {
  const showAdditionalFilters = Security.canViewAdditionalFilters
  const { channel } = useChannel()
  const { data: additionalFilters, isPending: areAdditionalFiltersPending } =
    useQueueStatsFilterQuery(
      {
        channel,
      },
      { enabled: showAdditionalFilters },
    )

  return (
    <AdditionalFiltersProvider initialFilters={additionalFilters}>
      <Page.Tabs>
        <GlobalFilters
          additionalFilters={additionalFilters}
          showAdditionalFilters={showAdditionalFilters}
          areAdditionalFiltersPending={areAdditionalFiltersPending}
        />
      </Page.Tabs>

      <Page.Main>
        <Box mt="s-16">{children}</Box>
      </Page.Main>
    </AdditionalFiltersProvider>
  )
}
